export default class ApiDropdown {
  constructor() {
    this.endpoint = $('.endpoint ul');
    this.endpoint.find('p:nth-of-type(2)').remove();

    const options = $(
      '.api-method-example ul.itemizedlist li:first-of-type p'
    ).map((i, el) => `<option value=${i}>${el.innerHTML}</option>`);
    const dropdown = `<select class="form-control" id="api-select">${Object.values(
      options
    ).join()}</select>`;
    this.endpoint.append(dropdown);

    this.apiContainer = $(`div.api-method-example`);
    this.apiContainer.eq(0).addClass('active');

    const webhookCaption = this.apiContainer
      .find('li.listitem:first-child p')
      .text();
    this.apiContainer
      .find('.example-webhook')
      .attr('data-content', webhookCaption || 'Example Webhook');

    this.apiSelect = $('#api-select');
  }

  listenEvents() {
    this.apiSelect.on('change', e => {
      const index = e.target.value;
      this.apiContainer.removeClass('active');
      this.apiContainer.eq(index).addClass('active');
    });
  }

  stopListening() {
    this.apiSelect.off('change');
  }
}
